(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aluxio-offers"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__aluxioCopyBound) return;
    window.__aluxioCopyBound = true;

    /* Synchronous first: execCommand must run inside the click gesture, and it still works
       everywhere, including the theme-editor iframe where the async Clipboard API is refused. */
    function copySync(text) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;font-size:16px;';
      document.body.appendChild(area);

      // iOS Safari only copies from an editable, range-selected element.
      area.contentEditable = 'true';
      area.readOnly = false;
      var range = document.createRange();
      range.selectNodeContents(area);
      var selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      area.setSelectionRange(0, text.length);

      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      selection.removeAllRanges();
      document.body.removeChild(area);
      return ok;
    }

    function copyText(text) {
      if (copySync(text)) return Promise.resolve(true);
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).then(function () { return true; }, function () { return false; });
      }
      return Promise.resolve(false);
    }

    function flash(button, ok) {
      var label = button.querySelector('[data-aluxio-copied]');
      var iconCopy = button.querySelector('[data-aluxio-icon-copy]');
      var iconDone = button.querySelector('[data-aluxio-icon-done]');
      if (label) {
        label.textContent = ok ? (button.getAttribute('data-copied-label') || 'Copied') : (button.getAttribute('data-failed-label') || 'Press Ctrl+C');
        label.hidden = false;
      }
      if (ok && iconCopy && iconDone) { iconCopy.hidden = true; iconDone.hidden = false; }
      button.classList.add('is-copied');
      window.setTimeout(function () {
        if (label) label.hidden = true;
        if (iconCopy && iconDone) { iconCopy.hidden = false; iconDone.hidden = true; }
        button.classList.remove('is-copied');
      }, 1600);
    }

    function onClick(event) {
      var target = event.target;
      if (!target || !target.closest) target = target && target.parentElement;
      var button = target && target.closest('[data-aluxio-copy]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      try {
        copyText(button.getAttribute('data-aluxio-copy')).then(
          function (ok) { flash(button, ok); },
          function () { flash(button, false); }
        );
      } catch (e) {
        flash(button, false);
      }
    }

    // Capture phase: runs ahead of any listener the theme editor attaches to the preview.
    document.addEventListener('click', onClick, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
